"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCamelCase = exports.isObject = exports.isArray = exports.camelCase = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _mapObj = require("map-obj");

var _mapObj2 = _interopRequireDefault(_mapObj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelCase = exports.camelCase = function camelCase(value) {
  return value.replace(/_([a-z])/g, function (item) {
    return item[1].toUpperCase();
  });
};

var isArray = exports.isArray = Array.isArray;

var isObject = exports.isObject = function isObject(data) {
  var dataType = typeof data === "undefined" ? "undefined" : _typeof(data);
  return Boolean(data) && (dataType === "object" || dataType === "function");
};

var toCamelCase = exports.toCamelCase = function toCamelCase(data) {
  if (isArray(data)) {
    return data.map(toCamelCase);
  } else if (isObject(data)) {
    return (0, _mapObj2.default)(data, function (key, value) {
      return [camelCase(key), toCamelCase(value)];
    });
  }
  return data;
};

exports.default = {
  camelCase: camelCase,
  isArray: isArray,
  isObject: isObject,
  toCamelCase: toCamelCase
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-utils-js/lib/utils.js
 ** module id = 397
 ** module chunks = 0
 **/